import Render from '@Views/root/user/context-main.html'
import { Component, Vue } from 'vue-property-decorator'
import { IOffice, IRatialBar, IUser } from '@Store/types'
import { Gravatar, Office } from '@Models/index'
import { GravatarService } from '@Services/index'
import { office, user } from '@Store/modules'
import { Profile } from '@Enums/profile'

@Render
@Component({})
export class ContextMain extends Vue {

	hasAvatar: boolean = false
	private service: GravatarService

	//#region Getter
	get state(): number {
		if (!this.user) return 0

		let count: number = 0
		let result: number = 0

		count++
		result += this.checkTitle() ? 1 : 0
		count++
		result += this.checkOrganization() ? 1 : 0
		count++
		result += this.checkEducation() ? 1 : 0
		// les champs RFE (NAF) ignorés pour secrétaires/comptables afin de ne pas
		// fausser leur taux de complétude. La TVA est exclue : champ non obligatoire
		// et masqué (redeviendra obligatoire au 01/09/2026).
		if (this.canShowRfeFields) {
			count++
			result += this.checkNaf() ? 1 : 0
			count++
			result += this.checkCompanyName() ? 1 : 0
		}
		count++
		result += this.hasAvatar ? 1 : 0

		return Math.round(count === 0 ? 100 : (result * 100 / count))
	}
	// ici je masque les champs RFE (TVA, NAF, adresse société) qui ne concernent pas le profil
	// secrétaires ni le comptables.
	get canShowRfeFields(): boolean {
		return !!this.user && this.user.profile !== Profile.Secretary && this.user.profile !== Profile.Accounting
	}
	get legends(): {label: string, color: string}[] {
		return [
			{label: this.$i18n.t('vm.root.user.context-main.legends.user').toString(), color: '#008FFB'},
			{label: this.$i18n.tc('vm.root.user.context-main.legends.offices', this.offices.length).toString(), color: '#00C376'}
		]
	}
	get series(): number[] {
		return [this.state, this.stateOffice]
	}
	get chartOptions(): IRatialBar {
		return {
			chart: {
				type: 'radialBar',
				fontFamily: 'inherit'
			},
			plotOptions: {
				radialBar: {
					hollow: {
						size: `40%`
					},
					dataLabels: {
						name: {
							show: true,
						},
						value: {
							fontSize: '20px',
							show: true,
						}
					}
				},
			},
			labels: this.legends.map(l => { return l.label }),
			legend: {
				show: false
			},
			colors: this.legends.map(l => { return l.color }),
			stroke: {
				lineCap: 'round'
			}
		}
	}
	private get user(): IUser {
		return user.user
	}
	private get stateOffice(): number {
		let count: number = 0
		let sum: number = 0
		for (let _office of this.offices) {
			count++
			sum += Office.getState(_office, office.setting(_office.id), office.schedule(_office.id), this.user)
		}
		return Math.round(count === 0 ? 0 : (sum / count))
	}
	private get offices() : IOffice[] {
		return office.offices.filter(o => { return office.isActive(o) })
	}
	private get gravatarId(): string {
		return Gravatar.getGravatarId(this.user.email)
	}
	//#endregion

	mounted() {
		this.service = new GravatarService()
		this.checkAvatar()
	}
	checkTitle(): boolean {
		return !!this.user && !!this.user.coordinates.title
	}
	checkOrganization(): boolean {
		return !!this.user && !!this.user.organizations && !!this.user.organizations.currents && this.user.organizations.currents.length > 0
	}
	checkEducation(): boolean {
		return !!this.user && !!this.user.formations && !!this.user.formations.currents && this.user.formations.currents.length > 0
	}
	checkNaf(): boolean {
		return !!this.user && !!this.user.coordinates.naf
	}
	checkCompanyName(): boolean {
		return !!this.user && !!this.user.coordinates.company_name
	}
	checkAddress(): boolean {
		let address = this.user && this.user.coordinates ? this.user.coordinates.address : null
		return !!address && !!address.street && !!address.zipcode && !!address.city
	}
	private checkAvatar(): void {
		this.hasAvatar = false
		if (Gravatar.defaultGravatarId === this.gravatarId)
			return

		try {
			this.service.exists(this.gravatarId)
			.then(response => {
				if (response.status !== 200) return

				this.hasAvatar = response.data.entry[0].requestHash === this.gravatarId
			})
		} catch(err) {}
	}
}
